import { ReferenceCreatedByFields } from 'drapcode-constant';
import { getFieldOptionsForSelect } from '../pluginComponentApi';

export default function (editor, opt = {}) {
  const traitManager = editor.TraitManager;
  const { collectionOptions } = opt;
  const style = document.createElement('style');
  style.innerHTML = `
        .checkmark::after {
            left: 4px;
            top: 4px;
        }
        checkbox{
        all:unset;
        }
       
        select option:first-child {
            color: grey;
        }
        select.empty {
            color: grey;
        }
        select option[disabled]:first-child {
            display: none;
        }
        .input[type=data-group-text] {
            display:none;
        }
        .width100{
          width: 100%;
        }
  `;
  document.head.appendChild(style);
  traitManager.addType('data-group-field-src', {
    createInput({ trait }) {
      const options = trait.get('options') || [];
      const el = document.createElement('div');
      el.classList.add('custom-field');
      el.innerHTML = `    
    <div id="URL">
    <div class="form-group">
    <label>
      <input type="checkbox" name="getSrcFrom" style="all: revert;"/>
      Get Image From ${trait.get('collectionTitle')}
    </label>
    </div>
    <div class="form-group">
         <div id="select-field-div" style="display: none">
          <select class="selectField form-control form-control-sm options-light"></select>
         </div>
     </div>
    </div>
    `;
      // const radioButton = el.querySelector("input[name=getTextFrom]");
      const checkbox = el.querySelector('input[type=checkbox][name="getSrcFrom"]');
      const selectFieldDiv = el.querySelector('#select-field-div');
      const selectField = el.querySelector('.selectField');
      checkbox.addEventListener('click', async (ev) => {
        if (ev.target.checked) {
          selectField.innerHTML = getFieldOptionsForSelect(options);
          selectFieldDiv.style.display = 'block';
        } else {
          selectFieldDiv.style.display = 'none';
        }
      });
      return el;
    },
    onEvent({ elInput, component }) {
      onTraitsChange(elInput, component, this.model);
    },
    onUpdate({ elInput, component }) {
      onTraitsUpdate(elInput, component, this.model);
    },
  });
  traitManager.addType('data-group-field-uuid', {
    onEvent({ elInput, component }) {
      onTraitsChange(elInput, component, this.model);
    },
    onUpdate({ elInput, component }) {
      onTraitsUpdate(elInput, component, this.model);
    },
  });
  traitManager.addType('data-group-field', {
    createInput({ trait }) {
      const options = trait.get('options') || [];
      const el = document.createElement('div');
      el.classList.add('custom-field');
      el.innerHTML = `    
    <div id="URL">
    <div class="form-group">
    <label>
                    <input type="checkbox" name="getTextContent"
                           style="all: revert;"/>
                    ${trait.get('title')}
                </label>
      
    </div>
    <div class="form-group">
         <div id="field-text-select-div" style="display: none">
               <select class="field-text-select form-control form-control-sm options-light">
                   
               </select>
         </div>
     </div>
    </div>
    `;
      // const radioButton = el.querySelector("input[name=getTextFrom]");
      const checkbox = el.querySelector('input[type=checkbox][name="getTextContent"]');
      const selectFieldDiv = el.querySelector('#field-text-select-div');
      const selectField = el.querySelector('.field-text-select');
      checkbox.addEventListener('click', async (ev) => {
        if (ev.target.checked) {
          selectField.innerHTML = getFieldOptionsForSelect(options);
          selectFieldDiv.style.display = 'block';
        } else {
          selectFieldDiv.style.display = 'none';
        }
      });
      return el;
    },
    onEvent({ elInput, component }) {
      onTraitsChange(elInput, component, this.model);
    },
    onUpdate({ elInput, component }) {
      onTraitsUpdate(elInput, component, this.model);
    },
  });
  traitManager.addType('data-progress-now', {
    createInput({ trait }) {
      const options = trait.get('options') || [];
      const el = document.createElement('div');
      el.classList.add('custom-field');
      el.innerHTML = `    
    <div id="PROGRESS-NOW">
    <div class="form-group">
    <label>
                    <input type="checkbox" name="getProgressNowContent"
                           style="all: revert;"/>
                    ${trait.get('title')}
                </label>
      
    </div>
    <div class="form-group">
         <div id="progress-now-select-div" style="display: none">
               <select class="progress-now-select form-control form-control-sm options-light">
                   
               </select>
         </div>
     </div>
    </div>
    `;
      const checkbox = el.querySelector('input[type=checkbox][name="getProgressNowContent"]');
      const selectFieldDiv = el.querySelector('#progress-now-select-div');
      const selectField = el.querySelector('.progress-now-select');
      checkbox.addEventListener('click', async (ev) => {
        if (ev.target.checked) {
          selectField.innerHTML = '';
          let optionHtml = `<option value="" selected>- Select One -</option>
                              <option value="" >None</option>`;
          optionHtml += `${options
            .map((opt) => `<option value="${opt.id.split('"').join("'")}">${opt.name}</option>`)
            .join('')}`;
          selectField.innerHTML = optionHtml;
          selectFieldDiv.style.display = 'block';
        } else {
          selectFieldDiv.style.display = 'none';
        }
      });
      return el;
    },
    onEvent({ elInput, component }) {
      onProgressNowTraitsChange(elInput, component, this.model);
    },
    onUpdate({ elInput, component }) {
      onProgressNowTraitsUpdate(elInput, component, this.model);
    },
  });
  traitManager.addType('data-progress-min', {
    createInput({ trait }) {
      const options = trait.get('options') || [];
      const el = document.createElement('div');
      el.classList.add('custom-field');
      el.innerHTML = `    
    <div id="PROGRESS-MIN">
    <div class="form-group">
    <label>
                    <input type="checkbox" name="getProgressMinContent"
                           style="all: revert;"/>
                    ${trait.get('title')}
                </label>
      
    </div>
    <div class="form-group">
         <div id="progress-min-select-div" style="display: none">
               <select class="progress-min-select form-control form-control-sm options-light">
                   
               </select>
         </div>
     </div>
    </div>
    `;
      const checkbox = el.querySelector('input[type=checkbox][name="getProgressMinContent"]');
      const selectFieldDiv = el.querySelector('#progress-min-select-div');
      const selectField = el.querySelector('.progress-min-select');
      checkbox.addEventListener('click', async (ev) => {
        if (ev.target.checked) {
          selectField.innerHTML = '';
          let optionHtml = `<option value="" selected>- Select One -</option>
                              <option value="" >None</option>`;
          optionHtml += `${options
            .map((opt) => `<option value="${opt.id.split('"').join("'")}">${opt.name}</option>`)
            .join('')}`;
          selectField.innerHTML = optionHtml;
          selectFieldDiv.style.display = 'block';
        } else {
          selectFieldDiv.style.display = 'none';
        }
      });
      return el;
    },
    onEvent({ elInput, component }) {
      onProgressMinTraitsChange(elInput, component, this.model);
    },
    onUpdate({ elInput, component }) {
      onProgressMinTraitsUpdate(elInput, component, this.model);
    },
  });
  traitManager.addType('data-progress-max', {
    createInput({ trait }) {
      const options = trait.get('options') || [];
      const el = document.createElement('div');
      el.classList.add('custom-field');
      el.innerHTML = `    
    <div id="PROGRESS-MAX">
    <div class="form-group">
    <label>
                    <input type="checkbox" name="getProgressMaxContent"
                           style="all: revert;"/>
                    ${trait.get('title')}
                </label>
      
    </div>
    <div class="form-group">
         <div id="progress-max-select-div" style="display: none">
               <select class="progress-max-select form-control form-control-sm options-light">
                   
               </select>
         </div>
     </div>
    </div>
    `;
      const checkbox = el.querySelector('input[type=checkbox][name="getProgressMaxContent"]');
      const selectFieldDiv = el.querySelector('#progress-max-select-div');
      const selectField = el.querySelector('.progress-max-select');
      checkbox.addEventListener('click', async (ev) => {
        if (ev.target.checked) {
          selectField.innerHTML = '';
          let optionHtml = `<option value="" selected>- Select One -</option>`;
          optionHtml += `${options
            .map((opt) => `<option value="${opt.id.split('"').join("'")}">${opt.name}</option>`)
            .join('')}`;
          selectField.innerHTML = optionHtml;
          selectFieldDiv.style.display = 'block';
        } else {
          selectFieldDiv.style.display = 'none';
        }
      });
      return el;
    },
    onEvent({ elInput, component }) {
      onProgressMaxTraitsChange(elInput, component, this.model);
    },
    onUpdate({ elInput, component }) {
      onProgressMaxTraitsUpdate(elInput, component, this.model);
    },
  });
  traitManager.addType('data-series-trait', {
    createInput({ trait }) {
      const options = trait.get('options') || [];
      const el = document.createElement('div');
      el.classList.add('custom-field');
      let optionHtml = `<option value="" selected>- Select One -</option>
                              <option value="">None</option>`;
      optionHtml += `${options
        .map((opt) => `<option value="${opt.id.split('"').join("'")}">${opt.name}</option>`)
        .join('')}`;
      el.innerHTML = `    
      <div id="DATA-MAP">
        <div class="form-group">
          <div id="data-map-select-div">
            <select id="${trait.get('title')}" class="form-control form-control-sm options-light">
                ${optionHtml}
            </select>
          </div>
        </div>
      </div>
    `;
      return el;
    },
    onEvent({ elInput, component, trait }) {
      // onDataMapTraitsChange(elInput, component, this.model, trait.get('title'));
      commonOnTraitsChange(elInput, component, this.model, trait.get('title'));
    },
    onUpdate({ elInput, component, trait }) {
      onDataMapTraitsUpdate(elInput, component, this.model, trait.get('title'));
    },
  });
  traitManager.addType('data-map-trait', {
    createInput({ trait }) {
      const options = trait.get('options') || [];
      const el = document.createElement('div');
      el.classList.add('custom-field');
      let optionHtml = `<option value="" selected>- Select One -</option>
                              <option value="">None</option>`;
      optionHtml += `${options
        .map((opt) => `<option value="${opt.id.split('"').join("'")}">${opt.name}</option>`)
        .join('')}`;
      el.innerHTML = `    
      <div id="DATA-MAP">
        <div class="form-group">
          <div id="data-map-select-div">
            <select id="${trait.get('title')}" class="form-control form-control-sm options-light">
                ${optionHtml}
            </select>
          </div>
        </div>
      </div>
    `;
      return el;
    },
    onEvent({ elInput, component, trait }) {
      // onDataMapTraitsChange(elInput, component, this.model, trait.get('title'));
      commonOnTraitsChange(elInput, component, this.model, trait.get('title'));
    },
    onUpdate({ elInput, component, trait }) {
      onDataMapTraitsUpdate(elInput, component, this.model, trait.get('title'));
    },
  });
  traitManager.addType('data-snipcart-trait', {
    createInput({ trait }) {
      const options = trait.get('options') || [];
      const el = document.createElement('div');
      el.classList.add('custom-field');
      let optionHtml = `<option value="" selected>- Select One -</option>
                              <option value="">None</option>`;
      optionHtml += `${options
        .map((opt) => `<option value="${opt.id.split('"').join("'")}">${opt.name}</option>`)
        .join('')}`;
      el.innerHTML = `    
      <div id="DATA-SNIPCART">
          <div id="data-snipcart-select-div">
            <select id="${trait.get('title')}" class="form-control form-control-sm options-light">
                ${optionHtml}
            </select>
          </div>
      </div>
    `;
      return el;
    },
    onEvent({ elInput, component, trait }) {
      // onDataSnipcartTraitsChange(elInput, component, this.model, trait.get('title'));
      commonOnTraitsChange(elInput, component, this.model, trait.get('title'));
    },
    onUpdate({ elInput, component, trait }) {
      onDataSnipcartTraitsUpdate(elInput, component, this.model, trait.get('title'));
    },
  });
  traitManager.addType('finder-query-param-trait', {
    createInput({ trait }) {
      const traitTitle = trait.get('title');
      const options = trait.get('options') || [];
      const el = document.createElement('div');
      el.classList.add('custom-field');
      let optionHtml = `<option value="" selected>- Select One -</option>
                              <option value="">None</option>`;
      optionHtml += `${options
        .map((opt) => `<option value="${opt.id.split('"').join("'")}">${opt.name}</option>`)
        .join('')}`;
      el.innerHTML = `    
      <div id="${traitTitle}_param">
        <div class="form-group">
          <div id="${traitTitle}-select">
            <select id="${trait.get('title')}" class="form-control form-control-sm options-light">
                ${optionHtml}
            </select>
          </div>
        </div>
      </div>
    `;
      return el;
    },
    onEvent({ elInput, component, trait }) {
      // onDataMapTraitsChange(elInput, component, this.model, trait.get('title'));
      commonOnTraitsChange(elInput, component, this.model, trait.get('title'));
    },
    onUpdate({ elInput, component, trait }) {
      onDataMapTraitsUpdate(elInput, component, this.model, trait.get('title'));
    },
  });
  traitManager.addType('data-group-href-field', {
    createInput({ trait }) {
      const options = trait.get('options') || [];
      const el = document.createElement('div');
      el.classList.add('custom-field');
      el.innerHTML = `    
      <div id="URL">
      <div class="form-group">
        <label>
          <input type="checkbox" name="getURLFrom" style="all: revert;" />
          ${trait.get('title')}
        </label>
      </div>
      <div class="form-group">
         <div id="field-url-select-div" style="display: none">
               <select class="field-url-select form-control form-control-sm options-light">
                   
               </select>
         </div>
     </div>
    </div>
    `;
      const checkbox = el.querySelector('input[type=checkbox][name="getURLFrom"]');
      const selectFieldDiv = el.querySelector('#field-url-select-div');
      const selectField = el.querySelector('.field-url-select');
      checkbox.addEventListener('click', async (ev) => {
        console.log('getURLFrom ev::::', ev, 'options::::', options);
        if (ev.target.checked) {
          selectField.innerHTML = '';
          let optionHtml = `<option value="" selected>- Select One -</option>
                              <option value="" >None</option>`;
          optionHtml += `${options
            .map((opt) => `<option value="${opt.id}">${opt.name}</option>`)
            .join('')}`;
          selectField.innerHTML = optionHtml;
          selectFieldDiv.style.display = 'block';
        } else {
          selectFieldDiv.style.display = 'none';
        }
      });
      return el;
    },
    onEvent({ elInput, component }) {
      onLinkTraitsChange(elInput, component, this.model);
    },
    onUpdate({ elInput, component }) {
      onLinkTraitsUpdate(elInput, component, this.model);
    },
  });
  //TODO: Can be made common trait
  traitManager.addType('data-stripe-trait', {
    createInput({ trait }) {
      const options = trait.get('options') || [];
      const el = document.createElement('div');
      el.classList.add('custom-field');
      let optionHtml = `<option value="" selected>- Select One -</option>
                              <option value="">None</option>`;
      optionHtml += `${options
        .map((opt) => `<option value="${opt.id.split('"').join("'")}">${opt.name}</option>`)
        .join('')}`;
      el.innerHTML = `    
          <div id="data-stripe-select-${trait.get('title')}-div">
            <select id="${trait.get('title')}" class="form-control form-control-sm options-light">
                ${optionHtml}
            </select>
          </div>
    `;
      return el;
    },
    onEvent({ elInput, component, trait }) {
      // onDataStripeTraitsChange(elInput, component, this.model, trait.get('title'));
      commonOnTraitsChange(elInput, component, this.model, trait.get('title'));
    },
    onUpdate({ elInput, component, trait }) {
      onDataStripeTraitsUpdate(elInput, component, this.model, trait.get('title'));
    },
  });
  traitManager.addType('data-bng-payment-trait', {
    createInput({ trait }) {
      const options = trait.get('options') || [];
      const el = document.createElement('div');
      el.classList.add('custom-field');
      let optionHtml = `<option value="" selected>- Select One -</option>
                              <option value="">None</option>`;
      optionHtml += `${options
        .map((opt) => `<option value="${opt.id.split('"').join("'")}">${opt.name}</option>`)
        .join('')}`;
      el.innerHTML = `    
          <div id="data-bng-payment-select-${trait.get('title')}-div">
            <select id="${trait.get('title')}" class="form-control form-control-sm options-light">
                ${optionHtml}
            </select>
          </div>
    `;
      return el;
    },
    onEvent({ elInput, component, trait }) {
      // onDataStripeTraitsChange(elInput, component, this.model, trait.get('title'));
      commonOnTraitsChange(elInput, component, this.model, trait.get('title'));
    },
    onUpdate({ elInput, component, trait }) {
      // onDataStripeTraitsUpdate(elInput, component, this.model, trait.get('title'));
      commonOnTraitsUpdate(elInput, component, this.model, trait.get('title'));
    },
  });
  traitManager.addType('data-fluid-pay-trait', {
    createInput({ trait }) {
      const options = trait.get('options') || [];
      const el = document.createElement('div');
      el.classList.add('custom-field');
      let optionHtml = `<option value="" selected>- Select One -</option>
                              <option value="">None</option>`;
      optionHtml += `${options
        .map((opt) => `<option value="${opt.id.split('"').join("'")}">${opt.name}</option>`)
        .join('')}`;
      el.innerHTML = `    
          <div id="data-bng-payment-select-${trait.get('title')}-div">
            <select id="${trait.get('title')}" class="form-control form-control-sm options-light">
                ${optionHtml}
            </select>
          </div>
    `;
      return el;
    },
    onEvent({ elInput, component, trait }) {
      // onDataStripeTraitsChange(elInput, component, this.model, trait.get('title'));
      commonOnTraitsChange(elInput, component, this.model, trait.get('title'));
    },
    onUpdate({ elInput, component, trait }) {
      // onDataStripeTraitsUpdate(elInput, component, this.model, trait.get('title'));
      commonOnTraitsUpdate(elInput, component, this.model, trait.get('title'));
    },
  });
  traitManager.addType('data-imagine-pay-trait', {
    createInput({ trait }) {
      const options = trait.get('options') || [];
      const el = document.createElement('div');
      el.classList.add('custom-field');
      let optionHtml = `<option value="" selected>- Select One -</option>
                              <option value="">None</option>`;
      optionHtml += `${options
        .map((opt) => `<option value="${opt.id.split('"').join("'")}">${opt.name}</option>`)
        .join('')}`;
      el.innerHTML = `    
          <div id="data-imagine-pay-select-${trait.get('title')}-div">
            <select id="${trait.get('title')}" class="form-control form-control-sm options-light">
                ${optionHtml}
            </select>
          </div>
    `;
      return el;
    },
    onEvent({ elInput, component, trait }) {
      commonOnTraitsChange(elInput, component, this.model, trait.get('title'));
    },
    onUpdate({ elInput, component, trait }) {
      commonOnTraitsUpdate(elInput, component, this.model, trait.get('title'));
    },
  });
  traitManager.addType('data-progress-percentage', {
    createInput({ trait }) {
      const options = trait.get('options') || [];
      const el = document.createElement('div');
      el.classList.add('custom-field');
      el.innerHTML = `    
      <div id="PROGRESS-PERCENTAGE">
      <div class="form-group">
      <label>
                      <input type="checkbox" name="getProgressPercentageContent"
                             style="all: revert;"/>
                      ${trait.get('title')}
                  </label>
        
      </div>
      <div class="form-group">
           <div id="progress-percentage-select-div" style="display: none">
                 <select class="progress-percentage-select form-control form-control-sm options-light">
                     
                 </select>
           </div>
       </div>
      </div>
      `;
      const checkbox = el.querySelector(
        'input[type=checkbox][name="getProgressPercentageContent"]',
      );
      const selectFieldDiv = el.querySelector('#progress-percentage-select-div');
      const selectField = el.querySelector('.progress-percentage-select');
      checkbox.addEventListener('click', async (ev) => {
        if (ev.target.checked) {
          selectField.innerHTML = '';
          let optionHtml = `<option value="" selected>- Select One -</option>
                                <option value="" >None</option>`;
          optionHtml += `${options
            .map((opt) => `<option value="${opt.id.split('"').join("'")}">${opt.name}</option>`)
            .join('')}`;
          selectField.innerHTML = optionHtml;
          selectFieldDiv.style.display = 'block';
        } else {
          selectFieldDiv.style.display = 'none';
        }
      });
      return el;
    },
    onEvent({ elInput, component }) {
      onProgressPercentageTraitsChange(elInput, component, this.model);
    },
    onUpdate({ elInput, component }) {
      onProgressPercentageTraitsUpdate(elInput, component, this.model);
    },
  });
}

const onTraitsChange = (elInput, component, traits) => {
  const traitsFieldAttr = traits.get('name');
  console.log('traitsFieldAttrtraitsFieldAttr', traitsFieldAttr);
  const select = elInput.querySelector('.field-text-select');
  console.log('select *** :>> ', select);
  console.log('select.options *** :>> ', select.options);
  const checkbox = elInput.querySelector('input[name="getTextContent"]:checked');
  console.log('checkbox *** :>> ', checkbox);
  let selectFieldValue = select.value;
  console.log('selectFieldValue selectFieldValue->', selectFieldValue);
  if (selectFieldValue.includes("'")) {
    selectFieldValue = selectFieldValue.split("'").join('"');
    console.log('selectFieldValueselectFieldValue:::::::::', selectFieldValue);
  }
  const selectedOption = select.options[select.selectedIndex];
  const fieldType = selectedOption.getAttribute('type');
  console.log('fieldTypefieldTypefieldType', fieldType);
  console.log('selectFieldValue::', selectFieldValue, '--', checkbox);
  let attr = component.getAttributes();
  const id = attr.id;
  const imageSrc = attr.src;
  const compType = component.get('type');

  if (['input', 'select', 'checkbox', 'file-input'].includes(compType)) {
    delete attr['data-form-element-collection'];
    delete attr['data-form-element-session'];
  } else if (compType !== 'link') {
    attr = {};
    attr.id = id;
  }
  if (compType === 'bs-image') {
    attr.src = imageSrc;
  }
  console.log('atttrrrrrrrrrrrr', attr);
  if (checkbox && selectFieldValue) {
    attr[traitsFieldAttr] = selectFieldValue;
    if (ReferenceCreatedByFields.includes(fieldType)) {
      attr['metaData'] = selectedOption.getAttribute('metaData').split("'").join('"');
    } else {
      delete attr['metaData'];
    }
    if (fieldType) {
      attr['data-field-type'] = fieldType;
    } else {
      delete attr['data-field-type'];
    }
    attr['type'] = fieldType;
  }

  component.setAttributes(attr);
  if (traitsFieldAttr !== 'data-img-src' && traitsFieldAttr !== 'data-form-element-data-group') {
    console.log('-----------------------', component.el);
    component.set('content', '');
    component.set(
      'content',
      select.options[select.selectedIndex] ? select.options[select.selectedIndex].text : '',
    );
  }
  console.log(component);
};
const onTraitsUpdate = (elInput, component, traits) => {
  const traitOptions = traits.get('options') || [];
  const attr = component.getAttributes();
  let selectedValue = attr[traits.get('name')];
  if (selectedValue) {
    const select = elInput.querySelector('.field-text-select');
    let checkbox = elInput.querySelector('input[name="getTextContent"]');
    checkbox.checked = true;
    const selectFieldDiv = elInput.querySelector('#field-text-select-div');
    select.innerHTML = getFieldOptionsForSelect(traitOptions);
    console.log('on traits update:::', selectedValue);
    if (selectedValue.includes('"')) {
      selectedValue = selectedValue.split('"').join("'");
    }
    select.value = selectedValue;
    selectFieldDiv.style.display = 'block';
  } else {
  }
};

const onLinkTraitsChange = (elInput, component, traits) => {
  const traitsFieldAttr = traits.get('name');
  console.log('onLinkTraitsChange traitsFieldAttrtraitsFieldAttr', traitsFieldAttr);
  const select = elInput.querySelector('.field-url-select');
  console.log('select *** :>> ', select);
  const checkbox = elInput.querySelector('input[name="getURLFrom"]:checked');
  console.log('checkbox *** :>> ', checkbox);
  let selectFieldValue = select.value;
  if (selectFieldValue.includes("'")) {
    selectFieldValue = selectFieldValue.split("'").join('"');
  }
  console.log('onLinkTraitsChange selectFieldValue::', selectFieldValue, '--', checkbox);
  let attr = component.getAttributes();
  const id = attr.id;
  if (component.get('type') !== 'link') {
    attr = {};
    attr.id = id;
  }
  console.log('onLinkTraitsChange atttrrrrrrrrrrrr', attr, 'traitsFieldAttr::::', traitsFieldAttr);
  if (checkbox && selectFieldValue) {
    attr[traitsFieldAttr] = selectFieldValue;
  }
  component.setAttributes(attr);

  if (traitsFieldAttr !== 'data-img-src') {
    console.log('-----------------------', component.el);
    component.set('data-href-content', '');
    component.set(
      'data-href-content',
      select.options[select.selectedIndex] ? select.options[select.selectedIndex].text : '',
    );
  }
  console.log(component);
};
const onLinkTraitsUpdate = (elInput, component, traits) => {
  const traitOptions = traits.get('options') || [];
  const attr = component.getAttributes();
  let selectedValue = attr[traits.get('name')];
  if (selectedValue) {
    const select = elInput.querySelector('.field-url-select');
    let checkbox = elInput.querySelector('input[name="getURLFrom"]');
    checkbox.checked = true;
    const selectFieldDiv = elInput.querySelector('#field-url-select-div');
    select.innerHTML = getFieldOptionsForSelect(traitOptions);

    if (selectedValue.includes('"')) {
      selectedValue = selectedValue.split('"').join("'");
    }
    select.value = selectedValue;
    selectFieldDiv.style.display = 'block';
  } else {
  }
};

const onProgressNowTraitsChange = (elInput, component, traits) => {
  const traitsFieldAttr = traits.get('name');
  const select = elInput.querySelector('.progress-now-select');
  const checkbox = elInput.querySelector('input[name="getProgressNowContent"]:checked');

  let selectFieldValue = select.value;
  const defaultNowValue = '25';
  if (selectFieldValue.includes("'")) {
    selectFieldValue = selectFieldValue.split("'").join('"');
  }
  let attr = component.getAttributes();

  if (checkbox && selectFieldValue) {
    attr[traitsFieldAttr] = selectFieldValue;
  } else {
    attr[traitsFieldAttr] = defaultNowValue;
  }
  component.setAttributes(attr);
};
const onProgressNowTraitsUpdate = (elInput, component, traits) => {
  const traitOptions = traits.get('options') || [];
  const attr = component.getAttributes();
  let selectedValue = attr[traits.get('name')];
  if (selectedValue) {
    const select = elInput.querySelector('.progress-now-select');
    let checkbox = elInput.querySelector('input[name="getProgressNowContent"]');
    checkbox.checked = true;
    const selectFieldDiv = elInput.querySelector('#progress-now-select-div');
    select.innerHTML = getFieldOptionsForSelect(traitOptions);
    if (selectedValue.includes('"')) {
      selectedValue = selectedValue.split('"').join("'");
    }
    select.value = selectedValue;
    selectFieldDiv.style.display = 'block';
  } else {
  }
};

const onProgressMinTraitsChange = (elInput, component, traits) => {
  const traitsFieldAttr = traits.get('name');
  const select = elInput.querySelector('.progress-min-select');
  const checkbox = elInput.querySelector('input[name="getProgressMinContent"]:checked');
  let selectFieldValue = select.value;
  const defaultMinValue = '0';
  if (selectFieldValue.includes("'")) {
    selectFieldValue = selectFieldValue.split("'").join('"');
  }
  let attr = component.getAttributes();
  if (checkbox && selectFieldValue) {
    attr[traitsFieldAttr] = selectFieldValue;
  } else {
    attr[traitsFieldAttr] = defaultMinValue;
  }
  component.setAttributes(attr);
};
const onProgressMinTraitsUpdate = (elInput, component, traits) => {
  const traitOptions = traits.get('options') || [];
  const attr = component.getAttributes();
  let selectedValue = attr[traits.get('name')];
  if (selectedValue) {
    const select = elInput.querySelector('.progress-min-select');
    let checkbox = elInput.querySelector('input[name="getProgressMinContent"]');
    checkbox.checked = true;
    const selectFieldDiv = elInput.querySelector('#progress-min-select-div');
    select.innerHTML = getFieldOptionsForSelect(traitOptions);

    if (selectedValue.includes('"')) {
      selectedValue = selectedValue.split('"').join("'");
    }
    select.value = selectedValue;
    selectFieldDiv.style.display = 'block';
  } else {
  }
};

const onProgressMaxTraitsChange = (elInput, component, traits) => {
  const traitsFieldAttr = traits.get('name');
  const select = elInput.querySelector('.progress-max-select');
  const checkbox = elInput.querySelector('input[name="getProgressMaxContent"]:checked');
  let selectFieldValue = select.value;
  const defaultMaxValue = '100';
  if (selectFieldValue.includes("'")) {
    selectFieldValue = selectFieldValue.split("'").join('"');
  }
  let attr = component.getAttributes();
  if (checkbox && selectFieldValue) {
    attr[traitsFieldAttr] = selectFieldValue;
  } else {
    attr[traitsFieldAttr] = defaultMaxValue;
  }
  component.setAttributes(attr);
};
const onProgressMaxTraitsUpdate = (elInput, component, traits) => {
  const traitOptions = traits.get('options') || [];
  const attr = component.getAttributes();
  let selectedValue = attr[traits.get('name')];
  if (selectedValue) {
    const select = elInput.querySelector('.progress-max-select');
    let checkbox = elInput.querySelector('input[name="getProgressMaxContent"]');
    checkbox.checked = true;
    const selectFieldDiv = elInput.querySelector('#progress-max-select-div');
    select.innerHTML = getFieldOptionsForSelect(traitOptions);

    if (selectedValue.includes('"')) {
      selectedValue = selectedValue.split('"').join("'");
    }
    select.value = selectedValue;
    selectFieldDiv.style.display = 'block';
  } else {
  }
};
// const onDataMapTraitsChange = (elInput, component, traits, title) => {
//   const traitsFieldAttr = traits.get('name');
//   const select = elInput.querySelector(`#${title}`);
//   let selectFieldValue = select.value;
//   if (selectFieldValue.includes("'")) {
//     selectFieldValue = selectFieldValue.split("'").join('"');
//   }
//   let attr = component.getAttributes();
//   if (selectFieldValue) {
//     attr[traitsFieldAttr] = selectFieldValue;
//   }
//   component.setAttributes(attr);
// };
const onDataMapTraitsUpdate = (elInput, component, traits, title) => {
  const attr = component.getAttributes();
  let selectedValue = attr[traits.get('name')];
  if (selectedValue) {
    const select = elInput.querySelector(`#${title}`);
    if (selectedValue.includes('"')) {
      selectedValue = selectedValue.split('"').join("'");
    }
    select.value = selectedValue;
  }
};
// const onDataSnipcartTraitsChange = (elInput, component, traits, title) => {
//   const traitsFieldAttr = traits.get('name');
//   const select = elInput.querySelector(`#${title}`);
//   let selectFieldValue = select.value;
//   if (selectFieldValue.includes("'")) {
//     selectFieldValue = selectFieldValue.split("'").join('"');
//   }
//   let attr = component.getAttributes();
//   if (selectFieldValue) {
//     attr[traitsFieldAttr] = selectFieldValue;
//   }
//   component.setAttributes(attr);
//   component.set(traitsFieldAttr, selectFieldValue ? selectFieldValue : '');
// };
const onDataSnipcartTraitsUpdate = (elInput, component, traits, title) => {
  const traitsFieldAttr = traits.get('name');
  const attr = component.getAttributes();
  let selectedValue = attr[traits.get('name')];
  if (selectedValue) {
    const select = elInput.querySelector(`#${title}`);
    if (selectedValue.includes('"')) {
      selectedValue = selectedValue.split('"').join("'");
    }
    select.value = selectedValue;

    let attr = component.getAttributes();
    if (selectedValue) {
      attr[traitsFieldAttr] = selectedValue;
    }
    component.setAttributes(attr);
  }
};
// const onDataStripeTraitsChange = (elInput, component, traits, title) => {
//   const traitsFieldAttr = traits.get('name');
//   const select = elInput.querySelector(`#${title}`);
//   let selectFieldValue = select.value;
//   if (selectFieldValue.includes("'")) {
//     selectFieldValue = selectFieldValue.split("'").join('"');
//   }
//   let attr = component.getAttributes();
//   if (selectFieldValue) {
//     attr[traitsFieldAttr] = selectFieldValue;
//   }
//   component.setAttributes(attr);
//   component.set(traitsFieldAttr, selectFieldValue ? selectFieldValue : '');
// };
const onDataStripeTraitsUpdate = (elInput, component, traits, title) => {
  const traitsFieldAttr = traits.get('name');
  let attr = component.getAttributes();
  const CUSTOMER_FROM_TRAIT_NAME = 'data-item-customer-from';
  const CUSTOMER_FIELD_TRAIT_NAME = 'data-item-customer-field';
  const customerFrom = component.get(CUSTOMER_FROM_TRAIT_NAME);
  let selectedValue = component.get(traitsFieldAttr)
    ? component.get(traitsFieldAttr)
    : attr[traitsFieldAttr];
  if (selectedValue) {
    const select = elInput.querySelector(`#${title}`);
    if (selectedValue.includes('"')) {
      selectedValue = selectedValue.split('"').join("'");
    }
    select.value = selectedValue;

    if (selectedValue) {
      attr[traitsFieldAttr] = selectedValue;
    }
    if (customerFrom) {
      attr[CUSTOMER_FROM_TRAIT_NAME] = customerFrom;
    } else {
      delete attr[CUSTOMER_FROM_TRAIT_NAME];
      delete attr[CUSTOMER_FIELD_TRAIT_NAME];
    }
    component.setAttributes(attr);
  }
};

const commonOnTraitsChange = (elInput, component, traits, title) => {
  console.log('title imagine_pay', title);
  console.log('traits imagine_pay', traits);
  const traitsFieldAttr = traits.get('name');
  console.log('traitsFieldAttr imagine_pay', traitsFieldAttr);
  const select = elInput.querySelector(`#${title}`);
  let selectFieldValue = select.value;
  if (selectFieldValue.includes("'")) {
    selectFieldValue = selectFieldValue.split("'").join('"');
  }
  let attr = component.getAttributes();
  if (selectFieldValue) {
    attr[traitsFieldAttr] = selectFieldValue;
  }
  component.setAttributes(attr);
  component.set(traitsFieldAttr, selectFieldValue ? selectFieldValue : '');
};
const commonOnTraitsUpdate = (elInput, component, traits, title) => {
  const traitsFieldAttr = traits.get('name');
  let attr = component.getAttributes();
  let selectedValue = component.get(traitsFieldAttr)
    ? component.get(traitsFieldAttr)
    : attr[traitsFieldAttr];
  if (selectedValue) {
    const select = elInput.querySelector(`#${title}`);
    if (selectedValue.includes('"')) {
      selectedValue = selectedValue.split('"').join("'");
    }
    select.value = selectedValue;

    if (selectedValue) {
      attr[traitsFieldAttr] = selectedValue;
    }

    component.setAttributes(attr);
  }
};

const onProgressPercentageTraitsChange = (elInput, component, traits) => {
  const traitsFieldAttr = traits.get('name');
  const select = elInput.querySelector('.progress-percentage-select');
  const checkbox = elInput.querySelector('input[name="getProgressPercentageContent"]:checked');

  let selectFieldValue = select.value;
  const defaultNowValue = traitsFieldAttr.includes('total') ? '100' : '25';
  if (selectFieldValue.includes("'")) {
    selectFieldValue = selectFieldValue.split("'").join('"');
  }
  let attr = component.getAttributes();

  if (checkbox && selectFieldValue) {
    attr[traitsFieldAttr] = selectFieldValue;
  } else {
    attr[traitsFieldAttr] = defaultNowValue;
  }
  component.setAttributes(attr);
};
const onProgressPercentageTraitsUpdate = (elInput, component, traits) => {
  const traitOptions = traits.get('options') || [];
  const attr = component.getAttributes();
  let selectedValue = attr[traits.get('name')];
  if (selectedValue) {
    const select = elInput.querySelector('.progress-percentage-select');
    let checkbox = elInput.querySelector('input[name="getProgressPercentageContent"]');
    checkbox.checked = true;
    const selectFieldDiv = elInput.querySelector('#progress-percentage-select-div');
    select.innerHTML = getFieldOptionsForSelect(traitOptions);
    if (selectedValue.includes('"')) {
      selectedValue = selectedValue.split('"').join("'");
    }
    select.value = selectedValue;
    selectFieldDiv.style.display = 'block';
  } else {
  }
};
